import preview_pie_img from '@/assets/preview-pie-chart.png';
import preview_bar_img from '@/assets/preview-bar-graph.png';
import preview_num_img from '@/assets/preview-number.png';

// 全ユーザで共通の値
const state = {
    categoryList: [
        {
            "categoryId": "all",
            "categoryName": "全て",
            "categoryOrder": "0"
        },
        {
            "categoryId": "category1",
            "categoryName": "カテゴリ1",
            "categoryOrder": "1"
        },
        {
            "categoryId": "category2",
            "categoryName": "カテゴリ2",
            "categoryOrder": "2"
        }
    ],
    firstSelectedCategory: "all",
    graphList: [
        {
            "graphName": "書類の利用状況",
            "graphDescription": "書類の利用状況を確認できます。",
            "graphImage": preview_pie_img,
            "graphId": "graph1",
            "graphType": "documentFrequency",
            "categoryId": "category1",
            "addFunction": "addDocumentFrequencyLayout"
        },
        {
            "graphName": "書類別の平均承認完了時間",
            "graphDescription": "各書類の承認完了までの平均時間を確認できます。",
            "graphImage": preview_bar_img,
            "graphId": "graph2",
            "graphType": "approvalDocumentTimeAverage",
            "categoryId": "category1",
            "addFunction": "addApprovalDocumentTimeAverageLayout"
        },
        {
            "graphName": "社員別の平均承認時間",
            "graphDescription": "各社員が承認するまでの平均時間を確認できます。",
            "graphImage": preview_bar_img,
            "graphId": "graph2",
            "graphType": "approvalTimeAverage",
            "categoryId": "category1",
            "addFunction": "addApprovalTimeAverageLayout"
        },
        {
            "graphName": "書類別の却下率",
            "graphDescription": "各書類の却下された割合を確認できます。",
            "graphImage": preview_bar_img,
            "graphId": "graph3",
            "graphType": "documentRejectionRate",
            "categoryId": "category1",
            "addFunction": "addDocumentRejectionRateLayout"
        },
        {
            "graphName": "社員別の申請データ却下率",
            "graphDescription": "各社員の申請データが却下された割合を確認できます。",
            "graphImage": preview_bar_img,
            "graphId": "graph3",
            "graphType": "userRejectionRate",
            "categoryId": "category1",
            "addFunction": "addUserRejectionRateLayout"
        },
        {
            "graphName": "デバイスの利用状況",
            "graphDescription": "デバイスの利用状況を確認できます。",
            "graphImage": preview_pie_img,
            "graphId": "graph5",
            "graphType": "deviceFrequency",
            "categoryId": "category1",
            "addFunction": "addDeviceFrequencyLayout"
        },
        {
            "graphName": "申請データの総数",
            "graphDescription": "申請データの総数を確認できます。",
            "graphImage": preview_num_img,
            "graphId": "graph6",
            "graphType": "applyDocumentNumber",
            "categoryId": "category1",
            "addFunction": "addApplyDocumentNumberLayout"
        },
        // {
        //     "graphName": "サンプルのグラフ",
        //     "graphDescription": "サンプル用のグラフです。",
        //     "graphImage": "https://qiita-user-contents.imgix.net/https%3A%2F%2Fqiita-image-store.s3.ap-northeast-1.amazonaws.com%2F0%2F123511%2Fd8ac32e1-0bf9-afb9-ec67-ccf51d1dee59.png?ixlib=rb-1.2.2&auto=compress%2Cformat&gif-q=60&s=50f8a54ebdf9105cdbb612f1fad2a42b",
        //     "graphId": "graph4",
        //     "graphType": "****",
        //     "categoryId": "category2",
        //     "addFunction": "addSampleChartLayout"
        // }
    ]


}

const getters = {
    categoryList: state => state.categoryList,
    firstSelectedCategory: state => state.firstSelectedCategory,
    graphList: state => state.graphList
}

const actions = {
}

const mutations = {
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
